import React from "react";
import { createRoot } from "react-dom/client";

import "./theme/css/index.css";
import App from "./App";
import { unregister } from "./serviceWorker";
import { registerLicense } from "@syncfusion/ej2-base";

//import config from "./config";

//registerLicense(config.syncfusionKey);

registerLicense("Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZecnVQRWReVEZxWkZWYEE=");

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
unregister();
